<template>
  <div>
    <h3>Домены</h3>

    <div class="row">

      <div class="col" v-if="domains.length > 0">
        <select class="form-select" v-model="selectedDomain">
          <option v-for="domain in domains" :key="domain.id" :value="domain.id">
            {{ domain.domain }}
          </option>
        </select>
      </div>

      <div class="col-auto">
        <DomainCreate @domainId="handleDomainUpdate" :service-id="props.serviceId"/>
      </div>
    </div>
    <br>

    <DomainDashboard v-if="selectedDomain" :domain-id="selectedDomain" :key="selectedDomain"/>
  </div>
</template>

<script setup>
import {computed, defineProps, ref} from "vue";
import {useDomainStore} from "@/store/domains";
import DomainDashboard from "@/components/domains/DomainDashboard";
import DomainCreate from "@/components/domains/DomainCreate";

const props  = defineProps({
  serviceId: Number,
})

const selectedDomain = ref('')
const domainStore = useDomainStore()
const domains = computed(() => domainStore.domains)

function handleDomainUpdate(domainId) {
  selectedDomain.value = domainId;
}

domainStore.getList({serviceId: props.serviceId})
    .then((domains) => {
      if(domains.length > 0) {
        selectedDomain.value = domains[0].id
      }
    })


</script>
